module.exports = __webpack_public_path__ + "static/media/8a.8d8d3353.jpg";